// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"411":"7900cd37","723":"6813d30e","728":"224e3eba","872":"56027888"}[chunkId] + ".chunk.css";
};